import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import pageDataService from "../../../../data-services/page-data.service";
import { LockMultipleCalls } from "../../../../services/promotion.services";
import { customPageDefaultData } from "../dafault-data-customize";
import ContentCustomPage from "./content.component";
import HeaderCustomPage from "./header.component";
export default function CustomPageDetailComponent(props) {
  const { pageName } = useParams();
  const { isCustomize, clickToFocusCustomize } = props;
  const formattedPageName = pageName?.replace(/-/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
  const [pageData, setPageData] = useState({ header: "", content: "" });
  const location = useLocation();

  const getIdFromUrl = () => {
    const params = new URLSearchParams(location.search);
    return params.get("id");
  };

  const colorGroupHeader = props?.general?.color?.colorGroups.find((c) => c.id === props?.config?.header?.colorGroupId);
  const colorGroupContent = props?.general?.color?.colorGroups.find(
    (c) => c.id === props?.config?.content?.colorGroupId,
  );

  useEffect(() => {
    if (!isCustomize) {
      const pageId = getIdFromUrl();
      if (pageId) {
        LockMultipleCalls(
          () => {
            getCustomPageData(pageId);
          },
          "handleCheckInventory",
          1000,
        );
      }
    } else {
      setPageData({ header: customPageDefaultData.header, content: customPageDefaultData.content });
    }
  }, [location]);

  async function getCustomPageData(id) {
    const pageData = await pageDataService.getPageDataByIdAsync(id);
    setPageData({ header: pageData?.data?.page?.pageName, content: pageData?.data?.page?.pageContent });
  }
  return (
    <div>
      <Helmet>
        <title>{formattedPageName}</title>
      </Helmet>
      <HeaderCustomPage
        data={pageData?.header}
        header={props?.config?.header}
        colorGroupHeader={colorGroupHeader}
        isCustomize={isCustomize}
        clickToFocusCustomize={clickToFocusCustomize}
      />
      <ContentCustomPage
        data={pageData?.content}
        content={props?.config?.content}
        colorGroupHeader={colorGroupHeader}
        isCustomize={isCustomize}
        clickToFocusCustomize={clickToFocusCustomize}
      />
    </div>
  );
}
